import React, {FunctionComponent} from 'react';
import StylesType from '@/types/StylesType';
import {Icon, Typography} from '@/components';
import {Row, Col,Badge} from 'antd';

export interface RoomHeadProps extends StylesType{
    title?: string;
    subtitle?: string;
}

export const RoomHead: FunctionComponent<RoomHeadProps> = props => {
  
    const {title , subtitle, prefixCls} = props;
  
    return (
        <Row className={prefixCls} type='flex' justify='space-between' align='top'>
            <Col>
                <Typography.Title level={2}>
                    <Icon className={`${prefixCls}-icon`} style={{marginLeft: '-20px'}} type='iconxuanzezhandian' />
                    {title}
                </Typography.Title>
                <Typography.Title type='secondary' level={4}><pre>{subtitle}</pre></Typography.Title>
            </Col>
            <Col>
                <Row>
                    <Col><Typography.Title level={4}>云手机服务站点状态</Typography.Title></Col>
                    <Col>
                        <Row type='flex' gutter={8}>
                            <Col><Badge status="success" text="推荐" /></Col>
                            <Col><Badge status="default" text="维护" /></Col>
                        </Row>
                    </Col>
                </Row>
            </Col>
        </Row>
    )
}

RoomHead.defaultProps = {
    prefixCls: 'gc-room-head',
    title: '选择云手机服务站点',
    subtitle: '海马云提供多站点服务，每个站点为独立管理系统设备购买及续费、文件上传等功能操作，\n只能在当前站点进行。'
}

export default RoomHead;
